export enum ETypeProduct{
    product = 1,
    service = 2
}

export enum EStatusProduct{
    delete = 0,
    active = 1,
    inactive = 2
}